import { render } from "./NotificationOverlay.vue?vue&type=template&id=5950dbe1"
import script from "./NotificationOverlay.vue?vue&type=script&lang=js"
export * from "./NotificationOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__